import type { FlowHealth } from '@interfaces/IFlowView';
import { ActivityIcon, TrendUpIcon, WarningTriangleIcon } from '@utils/icons';
import styles from './FlowHealthPills.module.css';

type IFlowHealthPillsProps = {
  health: FlowHealth;
  labels: { flowHealth: string; overall: string; exceptions: string };
};

/** The page's controls slot: the three health readouts, right of the title. */
export function FlowHealthPills({ health, labels }: IFlowHealthPillsProps) {
  return (
    <>
      <span className={styles.pill}>
        <ActivityIcon size={14} />
        <span className={styles.pillLabel}>{labels.flowHealth}</span>
        <span className={styles.pillValue}>{health.flowHealth}%</span>
      </span>
      <span className={styles.pill}>
        <TrendUpIcon size={14} />
        <span className={styles.pillLabel}>{labels.overall}</span>
        <span className={styles.pillValue}>{health.overall}%</span>
      </span>
      <span className={`${styles.pill} ${styles.pillAlert}`}>
        <WarningTriangleIcon size={14} />
        <span className={styles.pillLabel}>{labels.exceptions}</span>
        <span className={styles.pillValue}>{health.exceptions}</span>
      </span>
    </>
  );
}
